import { Calendar, MapPin, MoveUpRight } from 'lucide-react';
import { useEffect } from "react";
import { getCssVariable } from 'src/utils/utils';
import { Typography } from 'src/components/shared';
import Layout from '../Layout/Layout';


const AdobeSummitSlalom = () => {
  const primaryColor = getCssVariable('--primary-color');

  return (
    <Layout
      style={{
        color: primaryColor,
      }}
      hamburgerStyle={{
        backgroundColor: primaryColor,
      }}
      saleClassName={'btn-gradient-bdr'}
      headerStyle={{ position: 'relative' }}
    >
      <div className="content-left-img-component" style={{paddingBottom:"300px"}}>
        <div className="container-fluid custom-spacer-col">
          <div className="row align-items-start">
            {/* Left Column */}
            <div className="col-md-6 h-full flex flex-col justify-center mb-5 mb-md-0">
              <div className="d-flex flex-column align-items-start pe-m-0 max-w-450">
                <Typography 
                  tag="h2" 
                  style={{ display: 'inline-block', maxWidth: 'calc(14ch)', whiteSpace: 'normal' }}
                  className="mb-20"
                >
                  Gradial at Adobe Summit 2025
                </Typography>
                <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                  Connect with us at the upcoming Adobe Summit and learn about how our product is transforming content operations. Stay tuned for more on how to connect with us at the event.
                </Typography>
              </div>
              <div className="summit-event">
                <div className="summit-event-title">
                  <Typography tag="h3">
                    Partner Day Happy Hour
                  </Typography>
                  <Typography tag="p" className="grey-medium-dark mx-w-450">
                    Cocktails and conversations with fellow marketers and industry leaders in AI. 
                  </Typography>
                </div>
                <div className="summit-event-content">
                  <div className="summit-event-content-item">
                    <div className="summit-event-side-by-side">
                      <MapPin size={16} />
                      <Typography tag="h4">Where?</Typography>
                    </div>
                    <div className="summit-separator"></div>
                    <div className="summit-event-side-by-side">
                      <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                        Rosina Cocktail Club
                      </Typography>
                      <MoveUpRight size={16} />
                    </div>
                  </div>
                  <div className="summit-event-content-item">
                    <div className="summit-event-side-by-side">
                      <Calendar size={16} />
                      <Typography tag="h4">When?</Typography>
                    </div>
                    <div className="summit-separator"></div>
                    <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                      Monday, March 17, 2025 at 7:00 PM
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Column */}
            <div className="col-md-6 flex summit-event-right">
              <div className="summit-event-slalom-img"></div>
              <button className="btn-red-bdr" onClick={() => {
                window.open('https://www.eventbrite.com/e/gradial-and-hero-lunch-learn-tickets-1144929307379', '_blank');
              }}>
                Reserve your spot now
                {/* comment */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="6"
                  height="9"
                  viewBox="0 0 6 9"
                  fill="none"
                  className="btn-red-bdr-svg"
                >
                  <path
                    d="M1 7.75L3.78571 4.5L1 1.25"
                    stroke="red"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  className="btn-red-bdr-svg-hover"
                >
                  <path
                    d="M1 4.5h7"
                    stroke="red"  
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1 7.75L3.78571 4.5L1 1.25"
                    id="animated-path"
                    stroke="red"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
};

export default AdobeSummitSlalom;
